import { ILead } from 'interfaces/crm'
import { createContext } from 'react'

export const LeadContext = createContext<{
  lead?: ILead
  refetch?: CallableFunction
}>({})
